import { string } from "prop-types";

import {
  cssLength,
  iconSizeType,
  scaleLength,
} from "../components/cssLength";

import styled from "styled-components";

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  transform: translateY(-1px);
  width: ${({ $size }) => scaleLength($size, 1.25)};
  height: ${({ $size }) => cssLength($size)};
`;

const BulletOutline = ({ size, color }) => (
  <Wrapper $size={size}>
    <svg
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: scaleLength(size, 0.5),
        height: scaleLength(size, 0.5),
      }}
    >
      <circle
        cx="18"
        cy="18"
        r="14"
        fill="none"
        stroke={color}
        strokeWidth="7"
      />
    </svg>
  </Wrapper>
);

BulletOutline.propTypes = { size: iconSizeType, color: string };
export default BulletOutline;
